// extracted by mini-css-extract-plugin
module.exports = {"navigator-manager":"NavigatorManager_navigator-manager__1eG3V"};